export const BNB_SCORE_BASE: number = 5; //* Fixed base for BNB instance
export const DEFAULT_SCORE_BASE: number = 10; //* Default base if none found

export enum SCORE_BASES {
  FIVE = 5,
  TEN = 10,
}

export interface ScoreBaseOption {
  name: string;
  value: SCORE_BASES;
  checked?: boolean;
}

export const SCORING_BASE_OPTIONS: ScoreBaseOption[] = [
  { name: '0-10', value: SCORE_BASES.TEN, checked: false },
  { name: '0-5', value: SCORE_BASES.FIVE, checked: false },
];
